/**
 * Created by why on 2019/7/16.
 */
import {
  userList,
  getUserDisable,
  editUser,
  deleteUser,
  deleteByUser,
  saveUser,
  modifyEmail,
  modifyPass,
  getUserById,
  updateOwn,
  qqLogin
} from '@/api/user-manage'
export default {
  state: {
    list: [],
    userName: null,
    appType: null,
    status: null,
    loading: false,
    pageSize: 10,
    pageNum: 1,
    total: 0,
    saveLoading: false,
    checkList: [],
    userSex: '',
    createTime: '',
    email: '',
    loginCount: -1,
    userId: '',
    result: '',
    source: '',
    openId: '',
    errorMessage: '',
    avatarImgPath: '',
    registerType: null,
    memberStatus: null,
    shareOpenId: null
  },
  mutations: {
    setList (state, userList) {
      state.list = userList
    },
    setUserName (state, userName) {
      state.userName = userName
    },
    setStatus (state, status) {
      state.status = status
    },
    setUserLoading (state, loading) {
      state.loading = loading
    },
    setPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTotal (state, total) {
      state.total = total
    },
    setCheckList (state, checkList) {
      state.checkList = checkList
    },
    setSaveLoading (state, loading) {
      state.saveLoading = loading
    },
    setAppType (state, appType) {
      state.appType = appType
    },
    setCreateTime (state, createTime) {
      state.createTime = createTime
    },
    setEmail (state, email) {
      state.email = email
    },
    setLoginCount (state, count) {
      state.loginCount = count
    },
    setAvatar (state, avatarPath) {
      state.avatarImgPath = avatarPath
    },
    setUserId (state, id) {
      state.userId = id
    },
    setResult (state, result) {
      state.result = result
    },
    setErrorMessage (state, errorMessage) {
      state.errorMessage = errorMessage
    },
    setRegisterType (state, registerType) {
      state.registerType = registerType
    },
    setSource (state, source) {
      state.source = source
    },
    setOpenId (state, openId) {
      state.openId = openId
    },
    setMemberStatus (state, memberStatus) {
      state.memberStatus = memberStatus
    },
    setShareOpenId (state, shareOpenId) {
      state.shareOpenId = shareOpenId
    }
  },
  getters: {
    userList: state => state.list,
    userName: state => state.userName,
    appType: state => state.appType,
    status: state => state.status,
    loading: state => state.loading,
    total: state => state.total,
    checkList: state => state.checkList,
    saveLoading: state => state.saveLoading
  },
  actions: {
    getUserList ({ state, commit }) {
      commit('setUserLoading', true)
      return new Promise((resolve, reject) => {
        userList({
          username: state.userName,
          appType: state.appType,
          status: state.status,
          pageNum: state.pageNum,
          pageSize: state.pageSize,
          registerType: state.registerType,
          source: state.source,
          openId: state.openId,
          shareOpenId: state.shareOpenId,
          isMember: state.memberStatus
        }).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.pageSize
          const pageNum = data.pageNum
          const total = data.total
          commit('setCheckList', [])
          commit('setList', list)
          commit('setUserLoading', false)
          commit('setPageSize', pageSize)
          commit('setPageNum', pageNum)
          commit('setTotal', total)
          resolve()
        }).catch(err => {
          commit('setUserLoading', false)
          reject(err)
        })
      })
    },
    getUserDisable ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        getUserDisable(data).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    editUser ({ state, commit }, data) {
      commit('setSaveLoading', true)
      return new Promise((resolve, reject) => {
        editUser(data).then(res => {
          commit('setSaveLoading', false)
          resolve(res)
        }).catch(err => {
          commit('setSaveLoading', false)
          reject(err)
        })
      })
    },
    deleteUser ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        deleteUser(data).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    deleteByUser ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        deleteByUser(data).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    saveUser ({ state, commit }, data) {
      commit('setSaveLoading', true)
      return new Promise((resolve, reject) => {
        saveUser(data).then(res => {
          commit('setSaveLoading', false)
          resolve(res)
        }).catch(err => {
          commit('setSaveLoading', false)
          reject(err)
        })
      })
    },
    modifyEmail ({ state, commit }, data) {
      commit('setSaveLoading', true)
      return new Promise((resolve, reject) => {
        modifyEmail(data).then(res => {
          commit('setSaveLoading', false)
          resolve(res)
        }).catch(err => {
          commit('setSaveLoading', false)
          reject(err)
        })
      })
    },
    updateOwn ({ state, commit }, data) {
      commit('setSaveLoading', true)
      return new Promise((resolve, reject) => {
        updateOwn(data).then(res => {
          commit('setSaveLoading', false)
          resolve(res)
        }).catch(err => {
          commit('setSaveLoading', false)
          reject(err)
        })
      })
    },
    modifyPass ({ state, commit }, data) {
      commit('setSaveLoading', true)
      return new Promise((resolve, reject) => {
        modifyPass(data).then(res => {
          commit('setSaveLoading', false)
          resolve(res)
        }).catch(err => {
          commit('setSaveLoading', false)
          reject(err)
        })
      })
    },
    getUserById ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        getUserById(data).then(res => {
          const data = res.data.result
          commit('setUserId', data.id)
          commit('setEmail', data.email)
          commit('setAvatar', data.images)
          commit('setAccess', data.username)
          commit('setAppType', data.appType)
          commit('setCreateTime', data.createTime)
          commit('setLoginCount', data.loginCount)
          resolve(data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    qqLogin ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        qqLogin(data).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    setUserParam ({ commit }, {type, username, appType, status, pageSize, pageNum, checkList, registerType, source, openId, memberStatus, shareOpenId}) {
      switch (type) {
        case 'query' :
          return new Promise((resolve, reject) => {
            commit('setUserName', username)
            commit('setAppType', appType)
            commit('setStatus', status)
            commit('setRegisterType', registerType)
            commit('setSource', source)
            commit('setOpenId', openId)
            commit('setShareOpenId', shareOpenId)
            commit('setMemberStatus', memberStatus)
            resolve()
          })
        case 'page' :
          return new Promise((resolve, reject) => {
            commit('setPageSize', pageSize)
            commit('setPageNum', pageNum)
            resolve()
          })
        case 'clear' :
          return new Promise((resolve, reject) => {
            commit('setUserName', null)
            commit('setAppType', null)
            commit('setStatus', null)
            commit('setRegisterType', null)
            commit('setPageSize', pageSize)
            commit('setPageNum', pageNum)
            commit('setSource', null)
            commit('setOpenId', null)
            commit('setShareOpenId', null)
            commit('setMemberStatus', null)
            resolve()
          })
        default :
          return new Promise((resolve, reject) => {
            commit('setCheckList', checkList)
            resolve()
          })
      }
    },
    showMessage1 ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        commit('setResult', data)
        resolve()
      })
    },
    showErrorMessage ({ state, commit }, data) {
      return new Promise((resolve, reject) => {
        commit('setErrorMessage', data)
        resolve()
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user-manage.js